import { render, staticRenderFns } from "./Watermark.vue?vue&type=template&id=5a34e09a&scoped=true"
import script from "./Watermark.vue?vue&type=script&lang=ts"
export * from "./Watermark.vue?vue&type=script&lang=ts"
import style0 from "./Watermark.vue?vue&type=style&index=0&id=5a34e09a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a34e09a",
  null
  
)

export default component.exports